// @ts-check
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { PULSE_SUPPORTED_PM_SENSOR_IDS } from 'common/constants/constants';
import useSettingsService from 'components/hooks/useSettingsService';
import useDoraFeatureFlags from 'views/root/views/home/hooks/useDoraFeatureFlags';

/**
 *
 * @param {any[]} sensorAuthorizations Sensor authorizations
 * @param {boolean} isHidePulseEnabled Is hide pulse enabled?
 * @returns {boolean} Is pulse tab supported?
 */
const checkIfPulseTabIsSupported = (
  sensorAuthorizations,
  isHidePulseEnabled
) => {
  // pmSensors holds all jira/clubhouse sensor authorizations
  const pmSensorsSupportingPulse = sensorAuthorizations.filter(
    ({ sensor_id }) => PULSE_SUPPORTED_PM_SENSOR_IDS.includes(sensor_id)
  );
  return pmSensorsSupportingPulse.length > 0 && !isHidePulseEnabled;
};

/**
 * @typedef {object} TopBarSettingsResult
 * @property {boolean} shouldShowPulseTab Is pulse tab visible
 * @property {boolean} shouldLimitPeriodPicker Is period picker locked to a set period?
 */

/**
 *
 * @param {any[]} sensorAuthorizations
 * @param {boolean} isTeamLicense
 * @returns {TopBarSettingsResult} Top bar settings
 */
export const useTopBarSettings = (sensorAuthorizations, isTeamLicense) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isHidePulseEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.hidePulseEnabled
  });
  const { isAllControbutorsTeamSelected } = useDoraFeatureFlags();

  const shouldShowPulseTab =
    isTeamLicense ||
    checkIfPulseTabIsSupported(sensorAuthorizations, isHidePulseEnabled);

  /**
   * Period picker should be limited to past 90 days only and disabled
   * a tooltip should be shown when hovering over the period picker
   * @type {boolean}
   */
  const shouldLimitPeriodPicker = isAllControbutorsTeamSelected;

  return {
    shouldShowPulseTab,
    shouldLimitPeriodPicker
  };
};
